import { length } from './length'

export const measure = {
  length,
}
